let tocObserver: IntersectionObserver | null = null;

export function buildToc(
  preview: HTMLElement,
  tocList: HTMLElement,
  scrollContainer: HTMLElement,
): void {
  const headings = preview.querySelectorAll("h1, h2, h3, h4, h5, h6");
  tocList.innerHTML = "";

  if (headings.length === 0) {
    tocList.innerHTML =
      '<div style="padding:16px;color:var(--text-muted);font-size:var(--fs-xs);">No headings found</div>';
    return;
  }

  headings.forEach((h) => {
    const level = parseInt(h.tagName[1]);
    const link = document.createElement("a");
    link.className = "toc-item";
    link.dataset.level = String(level);
    link.textContent = (h.textContent || "").replace(/#$/, "").trim();
    link.href = `#${h.id}`;
    link.addEventListener("click", (e) => {
      e.preventDefault();
      h.scrollIntoView({ behavior: "smooth", block: "start" });
      tocList
        .querySelectorAll(".toc-item")
        .forEach((i) => i.classList.remove("active"));
      link.classList.add("active");
      history.replaceState(null, "", `#${h.id}`);
    });
    tocList.appendChild(link);
  });

  setupTocObserver(headings, tocList, scrollContainer);
}

function setupTocObserver(
  headings: NodeListOf<Element>,
  tocList: HTMLElement,
  scrollContainer: HTMLElement,
): void {
  if (tocObserver) tocObserver.disconnect();

  tocObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id;
          tocList.querySelectorAll(".toc-item").forEach((item) => {
            item.classList.toggle(
              "active",
              item.getAttribute("href") === `#${id}`,
            );
          });
        }
      });
    },
    { root: scrollContainer, rootMargin: "-20% 0px -60% 0px", threshold: 0 },
  );

  headings.forEach((h) => tocObserver!.observe(h));
}
